/* global axios */
import ApiClient from "./ApiClient";

class AnnouncementsAPI extends ApiClient {
  constructor() {
    super("announcements", { accountScoped: true });
  }

  get({ page = 1, perPage = 25 } = {}) {
    return axios.get(this.url, { params: { page, per_page: perPage } });
  }

  pending() {
    return axios.get(`${this.url}/pending`);
  }

  track(id, events) {
    return axios.post(`${this.url}/${id}/track`, { events });
  }

  markAllSeen() {
    return axios.post(`${this.url}/mark_all_seen`);
  }
}

export default new AnnouncementsAPI();
